import { GetScaleOrdersResponseProto } from "@noom/noom-contracts/noom_contracts/backend/scales/scale_order_service";
import { Api } from "@noom/noomscape";
import axios from "axios";

Api.register(
  "scales.getOrders",
  async ({
    accessCode,
    accessToken,
  }: {
    accessCode: string;
    accessToken: string;
  }) => {
    const response = await axios({
      baseURL: window.ENV.SERVER_URL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: "GET",
      url: `/users/${accessCode}/scales/orders`,
      urlWithPathParams: "/users/{accessCode}/scales/orders",
    });

    return response.data as GetScaleOrdersResponseProto;
  },
);
